module.exports = __webpack_public_path__ + "img/double-chevron-bottom.7c843eb2.svg";